import { useEffect } from "react";

declare global {
  interface Window {
    FB: any;
    fbAsyncInit: any;
  }
}

const permissions = [
  "public_profile",
  "email",
  "business_management",
  "pages_show_list",
  "instagram_basic",
  "instagram_manage_comments",
  "instagram_manage_insights",
  "instagram_manage_messages",
  "pages_read_engagement",
  "pages_manage_metadata",
  "pages_read_user_content",
  "pages_messaging",
];

const checkLoginState = (callback: (response: any) => void) => {
  window.FB.getLoginStatus((response: any) => {
    callback(response);
  });
};

export const handleFacebookLogin = (callback: (response: any) => void) => {
  window.FB.login(() => checkLoginState(callback), {
    scope: permissions.join(","),
    enable_profile_selector: true,
  });
};

export const FacebookSDKLoader = () => {
  useEffect(() => {
    window.fbAsyncInit = () => {
      console.log("Facebook SDK loaded");
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v19.0",
      });

      window.FB.AppEvents.logPageView();
    };

    // Carrega o SDK do Facebook
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode!.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);
  return null;
};
